module.exports = __webpack_public_path__ + "static/media/Final.a471f49c.png";